module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixdesk"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "tile is-child is-parent is-4"
  }, [_c('Offer', {
    attrs: {
      "rangeStart": "2",
      "rangeEnd": "3"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "tile is-vertical is-12"
  }, _vm._l((_vm.href.iframes), function(frame) {
    return _c('div', {
      staticClass: "column contains-iframe-to-center"
    }, [_c('ImageFrame', {
      key: frame,
      attrs: {
        "url": frame
      }
    })], 1)
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-parent"
  }, [_c('div', {
    staticClass: "tile is-vertical is-12"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/cowork/fixdesk.jpg",
      "loading": "lazy",
      "alt": "coworking bratislava fix desk"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-4"
  }, [_c('article', {
    staticClass: "tile"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/cowork/cowork_team_collaboration.jpg",
      "loading": "lazy",
      "alt": "coworking bratislava team collaboration room"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/community/IMG_20191023_182308.jpg",
      "loading": "lazy",
      "alt": "coworking bratislava team meeting room"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2090875d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FixDesk.vue
// module id = 240
// module chunks = 7